import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './theme.css';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './utils/auth';
import { CapabilityProvider } from './utils/capabilityContext';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <CapabilityProvider>
      <App />
    </CapabilityProvider>
  </AuthProvider>
);

reportWebVitals(); 
